import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_FUND_DISTRIBUTORS_DETAIL_API_ID =
  'FETCH_INVESTCORE_FUND_DISTRIBUTORS_DETAIL_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_FUND_DISTRIBUTORS_DETAIL_API_ID,
  ({ id, ...params }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/fund-distributors/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
